import React from 'react';
import styled from 'styled-components';
import SingleMultiSelectTextInput from './SingleMultiSelectInput';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';
import MultiSelectWrapper from '../../../ui/advisory-flow/components/shared-components/MultiSelectWrapper';

interface Props {
  question: FlowsQuestion;
}

const MultiSelectSimpleInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const {
    field: { value: selected, onBlur },
    error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const options = useQuestionEnum(question);

  const handleOnSingleSelected = (key: string) => {
    if (selected.includes(key))
      onBlur({
        name: question.id,
        value: selected.filter((_key: string) => key !== _key),
      });
    else
      onBlur({
        name: question.id,
        value: [...selected, key],
      });
  };

  const handleOnMultipleSelected = (items: string[]) => {
    onBlur({
      name: question.id,
      value: items,
    });
  };

  return (
    <MultiSelectWrapper
      question={question}
      selected={selected}
      onSelected={handleOnMultipleSelected}
      error={error?.message}
    >
      <TextOptionWrapper>
        {options?.map(({ label, value }) => {
          return (
            <SingleMultiSelectTextInput
              key={value}
              title={label}
              value={selected.includes(value)}
              onSelected={() => handleOnSingleSelected(value)}
            />
          );
        })}
      </TextOptionWrapper>
    </MultiSelectWrapper>
  );
};

const TextOptionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -2.4rem 0 0 -2.4rem;
  > * {
    margin: 2.4rem 0 0 2.4rem;
  }

  align-content: center;
  align-items: center;
`;

export default MultiSelectSimpleInputComponent;
